import styled from 'styled-components';
import colors from '@theme/colors';

const ButtonRow = styled.div`
  padding: 10px 0px;
  display: flex;
  flex-direction: row;
  > *:not(:first-child) {
    margin-left: 30px;
  }
`;

const ButtonRowLeft = styled(ButtonRow)`
  justify-content: flex-start;
`;

const ButtonRowRight = styled(ButtonRow)`
  justify-content: flex-end;
`;

const ButtonRowStickyRight = styled(ButtonRowRight)`
  justify-content: flex-end;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 5%;
  padding-right: 5%;
  background-color: ${colors.WHITE};
  border-top: 1px solid ${colors.PRIMARY};
  z-index: 10;
`;

ButtonRow.Left = ButtonRowLeft;
ButtonRow.Right = ButtonRowRight;
ButtonRow.StickyRight = ButtonRowStickyRight;

export default ButtonRow;



// WEBPACK FOOTER //
// ./components/layout/ButtonRow.js